const isFunctionCode = `import { isFunction } from 'cristatus';

const isFunction = isFunction(() => {}); //true
`;

export default isFunctionCode;
